import React from 'react';

export const formatMessage = (message: string): React.ReactNode => {
  if (!message) return '';

  if (message.match(/^\d+\./m)) {
    const lines = message.split('\n');
    return lines.map((line, index) => {
      if (line.match(/^\d+\./)) {
        return (
          <React.Fragment key={index}>
            {index > 0 && <br />}
            <div>{line}</div>
          </React.Fragment>
        );
      }
      return (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      );
    });
  }
  return message;
};
